import { useState } from 'react'
import { salespersonMyAPI } from '../../services/api'

function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage(null)

    if (newPassword.length < 4) {
      setMessage({ type: 'error', text: '새 비밀번호는 4자 이상이어야 합니다.' })
      return
    }

    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: '새 비밀번호가 일치하지 않습니다.' })
      return
    }

    setLoading(true)
    try {
      await salespersonMyAPI.changeMyPassword({
        currentPassword,
        newPassword,
      })
      setMessage({ type: 'success', text: '비밀번호가 변경되었습니다.' })
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch (error) {
      setMessage({ type: 'error', text: error.message || '비밀번호 변경에 실패했습니다.' })
    } finally {
      setLoading(false)
    }
  }

  return (
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-6">비밀번호 변경</h2>

        <div className="bg-white dark:bg-[#111118] rounded-2xl border border-slate-200 dark:border-[#282839] p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700 dark:text-slate-300 block">
                현재 비밀번호
              </label>
              <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                  className="w-full px-4 h-12 bg-slate-50 dark:bg-[#1c1c27] border border-slate-200 dark:border-[#3b3b54] rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700 dark:text-slate-300 block">
                새 비밀번호
              </label>
              <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  className="w-full px-4 h-12 bg-slate-50 dark:bg-[#1c1c27] border border-slate-200 dark:border-[#3b3b54] rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700 dark:text-slate-300 block">
                새 비밀번호 확인
              </label>
              <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="w-full px-4 h-12 bg-slate-50 dark:bg-[#1c1c27] border border-slate-200 dark:border-[#3b3b54] rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white"
              />
            </div>

            {message && (
                <div className={`p-4 rounded-xl border text-sm ${
                    message.type === 'success'
                        ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-700 text-green-800 dark:text-green-200'
                        : 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-700 text-red-800 dark:text-red-200'
                }`}>
                  <div className="flex items-center gap-2">
                    <span className="material-symbols-outlined text-base">
                      {message.type === 'success' ? 'check_circle' : 'error'}
                    </span>
                    <span>{message.text}</span>
                  </div>
                </div>
            )}

            <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-primary text-white rounded-xl font-bold text-sm hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                  <>
                    <span className="material-symbols-outlined animate-spin text-base">progress_activity</span>
                    변경 중...
                  </>
              ) : (
                  <>
                    <span className="material-symbols-outlined text-base">lock_reset</span>
                    비밀번호 변경
                  </>
              )}
            </button>
          </form>
        </div>
      </div>
  )
}

export default ChangePasswordPage
